import(/* webpackMode: "eager" */ "/vercel/path0/app/programm/page.tsx");
